import { object, array, number, string, boolean } from 'yup';
import { calculateQuantity } from 'src/MixAndMatchBundle/utils/calculateQuantity';
import { camelized_wearerBundleDetail_wearerBundleDetail_WearerBundlesProduct_bundle_items } from 'src/queries/__generated__/wearerBundleDetail';

export const getValidationSchema = (
    bundlesObject: camelized_wearerBundleDetail_wearerBundleDetail_WearerBundlesProduct_bundle_items[],
) =>
    object().shape({
        bundles: array().of(
            object()
                .shape({
                    id: number().required(),
                    products: array()
                        .of(
                            object()
                                .shape({
                                    id: number().required(),
                                    name: string().required(),
                                    selectedColorsAndSizes: array()
                                        .of(
                                            object()
                                                .shape({
                                                    colorId: number().required(),
                                                    sizes: object().shape({
                                                        id: number().required(),
                                                        quantity: number().min(1, '').required(),
                                                    }),
                                                })
                                                .required(),
                                        )
                                        .min(1, 'At least one position must be selected')
                                        .required(),
                                })
                                .required(),
                        )
                        .required(),
                })
                .test('maximum', `You've added too many items`, (values) => {
                    const config = bundlesObject.find((bundle) => bundle.optionId === values.id);

                    if (!values || !config) return true;

                    return calculateQuantity(values) <= config.maxQty;
                })
                .test('minimum', 'Please add proper number of items', (values) => {
                    const config = bundlesObject.find((bundle) => bundle.optionId === values.id);

                    if (!values || !config) return true;

                    return calculateQuantity(values) === config.maxQty;
                }),
        ),
        customisations: array()
            .of(
                object().shape({
                    selectedArtwork: string().required(),
                    isArtworkTemporary: boolean().required(),
                    selectedMethod: string().required(),
                    selectedOptions: object().shape({
                        textLineOne: string().when('selectedType', {
                            is: (selectedType: string) => selectedType === 'text',
                            then: (schema) => schema.required(),
                        }),
                        color: string().when('selectedType', {
                            is: (selectedType: string) => selectedType === 'text',
                            then: (schema) => schema.required(),
                        }),
                        font: string().when('selectedType', {
                            is: (selectedType: string) => selectedType === 'text',
                            then: (schema) => schema.required(),
                        }),
                    }),
                    selectedPositions: array()
                        .of(string())
                        .min(1, 'At least one position must be selected')
                        .required('Selected positions are required'),
                    availableMethodNumber: number().required(),
                    selectedType: string().required(),
                }),
            )
            .test('length', 'Please add any customisation', (values) => values?.length !== 0),
    });
